import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  booleanAttribute,
  inject,
  input,
  output
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SimIconComponent, SimIconType } from '@simOn/ui/sim-icon';

@Component({
  selector: 'layout-sim-sidemenu-item',
  imports: [SimIconComponent, RouterModule],
  styleUrl: './sim-sidemenu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <a
      class="sim-sidemenu-item flex align-center gap-6 sim-sidemenu-item--expanded"
      [class.sim-sidemenu-item--disabled]="isDisabled()"
      [routerLink]="link()"
      [relativeTo]="route"
      routerLinkActive="sim-sidemenu-item--active"
      #linkElement="routerLinkActive"
      (click)="click()"
    >
      <div class="sim-sidemenu-item__wrapper">
        <div class="sim-sidemenu-item__wrapper__icon-wrapper flex justify-content-center align-items-center">
          @if (imageSrc(); as imageSrc) {
            <img class="sim-sidemenu-item__image" [src]="imageSrc" alt="" />
          } @else if (icon()) {
            <sim-icon
              [sizeInPx]="24"
              sizeType="medium"
              class="sim-sidemenu-item__icon"
              [icon]="icon()!"
              [color]="linkElement.isActive ? 'var(--primary-hoover)' : 'var(--text-icon)'"
            />
          }
        </div>
        <span class="sim-sidemenu-item__wrapper__content text-small">
          <ng-content />
        </span>
      </div>
    </a>
  `
})
export class SimSideMenuItemComponent {
  protected route = inject(ActivatedRoute);
  readonly icon = input<SimIconType>();
  readonly imageSrc = input<string>();
  readonly link = input<string>();
  readonly isDisabled = input(false, { transform: booleanAttribute });
  readonly clicked = output<void>();

  click() {
    this.clicked.emit();
  }
}
